import { useMutation, useQueryClient } from "@tanstack/react-query";
import { businessServiceService } from "../../../services/businessServiceService";
import { serviceMapService } from "../../../services/serviceMapService";

export const useDeleteService = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      serviceMapId,
      serviceId,
    }: {
      serviceMapId: string;
      serviceId: string;
    }) => {
      await businessServiceService.delete(serviceMapId, serviceId);
      await serviceMapService.updateServiceStatuses(serviceMapId);
      return { serviceMapId, serviceId };
    },
    onSuccess: ({ serviceMapId, serviceId }) => {
      qc.invalidateQueries({ queryKey: ["serviceMapId", serviceMapId] });
      qc.invalidateQueries({ queryKey: ["service-events", serviceMapId, serviceId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
